import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const firebase = defineConnector({
  identifier: "firebase",
  name: "Firebase",
  tagLine: "Firebase Realtime Database REST API",
  keywords: "google gcp realtime database rtdb firebaseio",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ url }) =>
    url
      ? `${url}/.*`
      : "https://[^/]*\\.(firebaseio\\.com|firebasedatabase\\.app)/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create a Google OAuth 2.0 access token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://firebase.google.com/docs/database/rest/auth](https://firebase.google.com/docs/database/rest/auth) and [https://firebase.google.com/docs/reference/rest/database](https://firebase.google.com/docs/reference/rest/database). This draft uses a Google OAuth 2.0 access token in the `Authorization: Bearer` header for the Firebase Realtime Database REST API.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "baseUrl",
          label: "Realtime Database URL",
          placeholder: "https://your-project-default-rtdb.firebaseio.com",
          required: true,
          target: { kind: "configuration", field: "url" },
        },
        {
          kind: "input",
          label: "Google OAuth 2.0 access token",
          required: true,
          target: {
            kind: "secrets",
            field: "accessToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://your-project-default-rtdb.firebaseio.com/.json",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod, ...configuration }) => ({
      url: testUrl ?? (({ url }) => `${url}/.json`)(configuration),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
